// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card--1Ds7z","commentSectionContainer":"styles__commentSectionContainer--2wozK","wrapper":"styles__wrapper--iiVSV"};